export function getBackgroundImages (images: Parameters<typeof filterImagesBasedOnExisting>[0]) {
  return filterImagesBasedOnExisting(images);
}

export function removeImageSourceTagOnError (target: HTMLImageElement) {
  const {
    currentSrc,
    parentElement,
  } = target;
  ([...(parentElement?.children || [])]
    .find((child) => {
      if (child instanceof HTMLImageElement || child instanceof HTMLSourceElement) {
        return child.srcset === currentSrc;
      }
    })
    ?.remove?.()
  );
}

export function onImageComplete (
  imgElement: HTMLImageElement,
  {
    onImageLoad,
    onImageError,
  }: {
    onImageLoad?: (
      {
        target,
      }: {
        target: HTMLImageElement,
      },
    ) => unknown,
    onImageError?: (
      {
        target,
      }: {
        target: HTMLImageElement,
      },
    ) => unknown,
  } = {},
) {
  if ((imgElement instanceof HTMLImageElement) && imgElement.complete) {
    if (imgElement.naturalHeight || imgElement.naturalWidth) {
      onImageLoad?.({ target: imgElement });
    } else {
      onImageError?.({ target: imgElement });
    }
  }
}


function filterImagesBasedOnExisting (
  images: {
    url?: string | null,
    media?: string | null,
  }[],
): {
  url: string,
  media?: string | null,
}[] {
  const imagesArr = (Array.isArray(images) ? images : []);
  const existImages = (imagesArr
    .filter(
      (image): image is (typeof image & { url: string }) => {
        return !!image?.url;
      },
    )
  );

  if (existImages.length === 1 && existImages[0]) {
    existImages[0].media = null;
  }

  return existImages;
}
